<template>
  <div
    id="special-offer-badge"
    class="clickable"
    :class="{ pulsating: notClickedYet }"
    @click="handleBadgeClick"
  >
    <div id="badge-bg" class="bg-img to-center-abs">
      <div id="badge-icon" class="bg-img to-center-abs"></div>
    </div>
    <div
      id="countdown-box"
      class="to-center-abs w-100 d-inline-flex align-items-center justify-content-center"
    >
      <CountdownDigital
        :time="$store.getters['shop/getSpecialOfferTime']"
        :with-time-diff="true"
        @over="clearSpecialOffer"
      />
    </div>
    <div
      id="offer-box"
      class="bold text-white text-uppercase d-inline-flex align-items-center justify-content-center to-center-abs"
    >
      {{ $t("header.offer") }}
    </div>
    <!-- <AnimationIconSpecialOffer /> -->
  </div>
</template>
<script>
// import AnimationIconSpecialOffer from "@/components/animation/animation-spine-icon-special-offer.vue";
import CountdownDigital from "@/components/base/countdown-digital.vue";
export default {
  name: "SpecialOfferBadge",
  components: { CountdownDigital },
  data() {
    return {
      notClickedYet: true,
    };
  },
  methods: {
    clearSpecialOffer() {
      this.$store.commit("shop/setSpecialOffer", null);
    },
    handleBadgeClick() {
      this.notClickedYet = false;
      this.$root.$emit("show-special-offer");
    },
  },
};
</script>
<style lang="scss">
#special-offer-badge {
  z-index: 30;
  width: 118px;
  height: 126px;
  position: absolute;
  left: 0;
  top: -5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 16px;
  #badge-bg {
    background-image: url("@/assets/img/shop/offers/specialoffer_badge-bg.png");
    width: 100px;
    height: 100px;
    #badge-icon {
      background-image: url("@/assets/img/shop/offers/specialoffer_badge-icon.png");
      width: 65px;
      height: 54px;
      top: 12px;
      z-index: 10;
    }
  }
  #countdown-box {
    text-align: center;
    height: 37px;
    background-image: url("@/assets/img/shop/offers/specialoffer_countdown-bg.png");
    bottom: 30px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    z-index: 8;

    .countdown-digital {
      color: white;
      font-size: 20.3px;
      font-family: Ubuntu-Bold;
      text-shadow: 0 1px 5px $drop-shadow-dark, 0 1px 5px $drop-shadow-dark,
        0 1px 5px $drop-shadow-dark;
    }
  }
  #offer-box {
    bottom: 0;
    z-index: 31;
    height: 40px;
    width: 100px;
    background-image: url("@/assets/img/shop/offers/specialoffer_offer-bg.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 5;
  }
  &.pulsating {
    animation-name: pulse-and-rotate;
    animation-duration: 1.5s;
    animation-timing-function: ease-out;
    animation-direction: alternate;
    animation-iteration-count: infinite;
    animation-play-state: running;
    transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    perspective: 1000px;
  }
  @keyframes pulse-and-rotate {
    0% {
      transform: scale(0.9);
    }

    100% {
      transform: scale(1.2);
      transform: rotate(10deg);
    }
  }
}
</style>
